/**
 * @generated SignedSource<<6a9446b88d49260b311f93fd7c04895f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoTimelineUpdateEventCreated_todo$data = {
  readonly createdAtDate: {
    readonly " $fragmentSpreads": FragmentRefs<"StoreFormattedDate">;
  };
  readonly createdByActor: {
    readonly " $fragmentSpreads": FragmentRefs<"SignedActor_actor">;
  } | null;
  readonly " $fragmentType": "TodoTimelineUpdateEventCreated_todo";
};
export type TodoTimelineUpdateEventCreated_todo$key = {
  readonly " $data"?: TodoTimelineUpdateEventCreated_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoTimelineUpdateEventCreated_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoTimelineUpdateEventCreated_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "createdByActor",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SignedActor_actor"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "createdAtDate",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StoreFormattedDate"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "3028b8e10a278578c7d7024d4d02e2e0";

export default node;
